// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiArrowCollapseDown } from "@mdi/js";
import { Tooltip } from "antd";

import { ShapefileAction } from "../..";

interface IShapefileMoveToBottomActionProps {
  isDisabled?: boolean;
  moveToBottom: () => void;
  onContextMenuClose?: () => void;
}

export function ShapefileMoveToBottomAction({
  isDisabled,
  moveToBottom,
  onContextMenuClose
}: IShapefileMoveToBottomActionProps) {
  return (
    <Tooltip title="Move to bottom of all shapefiles" placement="right">
      <ShapefileAction
        disabled={isDisabled}
        onClick={(evt) => {
          moveToBottom();
          onContextMenuClose?.();
          evt.stopPropagation();
          evt.preventDefault();
        }}>
        <Icon path={mdiArrowCollapseDown} size={"18px"} />
        Move to Bottom
      </ShapefileAction>
    </Tooltip>
  );
}
